// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import ThemeSettings from "./components/settings";
import { ChartStyle } from "./components/chart";
import ScrollToTop from "./components/ScrollToTop";
import { ProgressBarStyle } from "./components/ProgressBar";
import NotistackProvider from "./components/NotistackProvider";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import { useEffect, useState } from "react";
import { authApi, eduleyApi } from "./api/apiConfig";
import { API_ENDPOINTS } from "./api/apiEndPoints";
import LoadingScreen from "./components/LoadingScreen";
import MaintenancePlanned from "./pages/MaintenancePlanned";
import MaintenanceUnplanned from "./pages/MaintenanceUnplanned";

// ----------------------------------------------------------------------

export default function App() {
  const [maintain, setMaintain] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkonmaintain();
  }, []);

  const checkonmaintain = async () => {
    setLoading(true);
    try {
      let res = await authApi.get(API_ENDPOINTS.MAINTAINANCE);
      setMaintain(res.data);
      console.log("res---", res);
    } catch (error) {}
    setLoading(false);
  };

  // allow_access_in_maintenance: false;
  // in_maintenance: true;
  const Checkmaintain = () => {
    if (loading) {
      <LoadingScreen />;
    }
    if (!maintain?.in_maintenance) {
      return (
        <>
          <Router />
        </>
      );
    }
    return (
      <>
        {maintain?.allow_access_in_maintenance ? (
          <Router />
        ) : (
          <MaintenanceUnplanned />
        )}
      </>
    );
  };

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        {/* <ThemeSettings> */}
        <NotistackProvider>
          <ProgressBarStyle />
          <ChartStyle />
          <ScrollToTop />
          {/* to check maintainance mode */}
          <Checkmaintain />
        </NotistackProvider>
        {/* </ThemeSettings> */}
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
